import type { ReactNode } from "react";
import { eyebrowClass, themeClasses, type Theme } from "@cw/design-tokens/theme";
import { Container } from "./Container";

export interface SectionProps { children: ReactNode; theme?: Theme; compact?: boolean; className?: string; id?: string }

export function Section({ children, theme = "paper", compact = false, className = "", id }: SectionProps) {
  const t = themeClasses(theme);
  return (
    <section id={id} className={`${t.surface} ${compact ? "py-12 md:py-16" : "py-16 md:py-24"} ${className}`.trim()}>
      {children}
    </section>
  );
}

export interface SectionHeaderProps {
  eyebrow?: string;
  heading?: string;
  intro?: ReactNode;
  theme?: Theme;
  align?: "left" | "center";
  as?: "h1" | "h2";
  /** Overrides the default bottom margin (mb-10 md:mb-14). */
  className?: string;
}

export function SectionHeader({ eyebrow, heading, intro, theme = "paper", align = "left", as: Tag = "h2", className = "mb-10 md:mb-14" }: SectionHeaderProps) {
  const t = themeClasses(theme);
  if (!heading && !eyebrow && !intro) return null;
  return (
    <header className={`${align === "center" ? "text-center mx-auto" : ""} max-w-3xl ${className}`}>
      {eyebrow ? <p className={`${eyebrowClass(theme)} mb-3 font-sans text-xs font-semibold uppercase tracking-[0.18em]`}>{eyebrow}</p> : null}
      {heading ? <Tag className={`${t.heading} text-display-md font-semibold`}>{heading}</Tag> : null}
      {intro ? <div className={`${t.prose} ${t.body} mt-5 text-lg`}>{intro}</div> : null}
    </header>
  );
}

export function ContainedSection({ children, ...rest }: SectionProps) {
  return <Section {...rest}><Container>{children}</Container></Section>;
}
